import useFilterOptionsBySearchQuery from './shared/hooks/useFilterOptionsBySearchQuery';
import type { FilterOption } from '../../shared/types';

/**
 * This component is here to make rerenderers in FilterMenu more granular
 * @param param0
 * @returns
 */
export default function OptionsFilteredBySearchQuery<T extends FilterOption>({
    options,
    children
}: {
    options: T[];
    children: (filteredOptions: T[]) => JSX.Element;
}) {
    const filteredOptions = useFilterOptionsBySearchQuery<T>(options);

    return children(filteredOptions);
}
